import { NgModule } from '@angular/core';
import { CustomlibUpdatedComponent } from './customlib-updated.component';



@NgModule({
  declarations: [CustomlibUpdatedComponent],
  imports: [
  ],
  exports: [CustomlibUpdatedComponent]
})
export class CustomlibUpdatedModule { }
